import { useTranslation } from 'react-i18next';
import { SttDialog } from '../sporttia/all';

type ModalConfirmationProps = {
    show: boolean;
    onClose: () => void;
    onAccept?: () => void;
};

/**
 * Confirmation dialog.
 */
export default function ModalConfirmation({
    show,
    onClose,
    onAccept,
}: ModalConfirmationProps) {
    const { t } = useTranslation();

    return (
        <SttDialog
            title={t('Information')}
            open={show}
            onClose={onClose}
            content={<>{t('AreYouSure')}</>}
            buttons={[
                {
                    type: 'accept',
                    onClick: onAccept,
                },
                {
                    type: 'cancel',
                    onClick: onClose,
                },
            ]}
        />
    );
}
